(function(){
  const btn = document.createElement('button');
  btn.textContent = 'Ask our Product Expert 💬';
  btn.style.position='fixed'; btn.style.bottom='20px'; btn.style.right='20px';
  btn.style.zIndex='9999'; btn.style.padding='12px 16px'; btn.style.borderRadius='9999px';
  btn.style.background='#111'; btn.style.color='white'; btn.style.border='none';
  btn.style.cursor='pointer'; btn.style.fontSize='14px';
  document.body.appendChild(btn);

  const panel = document.createElement('div');
  panel.style.position='fixed'; panel.style.bottom='80px'; panel.style.right='20px';
  panel.style.width='360px'; panel.style.maxWidth='90vw'; panel.style.height='480px';
  panel.style.background='white'; panel.style.border='1px solid #ddd';
  panel.style.borderRadius='16px'; panel.style.boxShadow='0 10px 30px rgba(0,0,0,.12)';
  panel.style.display='none'; panel.style.zIndex='10000';
  panel.innerHTML = `
    <div style="padding:10px; border-bottom:1px solid #eee; display:flex; justify-content:space-between;">
      <strong>Product Expert</strong>
      <button id="close-ai" style="border:none;background:none;cursor:pointer;">✕</button>
    </div>
    <div id="chat-area" style="padding:10px; overflow:auto; height:350px; font-size:14px;"></div>
    <div style="border-top:1px solid #eee; padding:8px;">
      <textarea id="chat-input" placeholder="Ask about use, benefits, or which product fits..." style="width:100%; height:60px; padding:8px; border:1px solid #ccc; border-radius:8px;"></textarea>
      <button id="send-ai" style="margin-top:6px; width:100%; padding:10px; border-radius:8px; border:none; background:#111; color:white; cursor:pointer;">Send</button>
    </div>
  `;
  document.body.appendChild(panel);

  const area = panel.querySelector('#chat-area');
  const input = panel.querySelector('#chat-input');

  function escapeHTML(s) {
  return s.replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
}

// Turns model text into a neat card: headings, bullets, spacing (ES/EN)
function formatAnswer(raw) {
  let t = (raw || '').trim();

  // Normalize newlines
  t = t.replace(/\r\n/g, '\n');

  // Promote common section headings
  const headings = [
    { re: /(^|\n)\s*(Pasos|Steps)\s*:/gi, label: '🪄 <strong>Pasos / Steps</strong>:' },
    { re: /(^|\n)\s*(Beneficios|Benefits)\s*:/gi, label: '✨ <strong>Beneficios / Benefits</strong>:' },
    { re: /(^|\n)\s*(Precauciones|Cautions?)\s*:/gi, label: '⚠️ <strong>Precauciones / Cautions</strong>:' },
    { re: /(^|\n)\s*(Cómo usar|How to use)\s*:/gi, label: '📝 <strong>Cómo usar / How to use</strong>:' }
  ];
  headings.forEach(h => { t = t.replace(h.re, '\n' + h.label + '\n'); });

  // Bold step numbers like "1. " → "<b>1.</b> "
  t = t.replace(/(^|\n)\s*(\d+)\.\s/g, (m, br, n) => `${br}<b>${n}.</b> `);

  // Turn "- " bullets into • bullets
  t = t.replace(/(^|\n)\s*-\s+/g, '$1• ');

  // Convert remaining newlines to <br>
  t = t.replace(/\n{2,}/g, '\n\n'); // collapse huge gaps
  t = t.replace(/\n/g, '<br>');

  // Wrap in a styled “card”
  return `
    <div style="
      background: linear-gradient(135deg,#111 0%,#333 100%);
      color:#fff; border-radius:12px; padding:12px 14px;
      line-height:1.55; font-size:14px;
    ">
      ${t}
    </div>
  `;
}

function addMsg(who, text){
  const el = document.createElement('div');
  el.style.margin = '10px 0';

  if (who === 'Assistant') {
    // Nicely formatted assistant card
    el.innerHTML = formatAnswer(text);
  } else {
    // User bubble (simple + safe)
    el.innerHTML = `
      <div style="
        display:inline-block; max-width:90%;
        background:rgba(0,0,0,.06); color:#111;
        padding:10px 12px; border-radius:12px;
      ">
        <b>${escapeHTML(who)}:</b> ${escapeHTML(text)}
      </div>
    `;
  }

  area.appendChild(el);
  area.scrollTop = area.scrollHeight;
}


async function askAI(q){
  addMsg('You', q);
  addMsg('Assistant', 'Typing…');

  try {
    const res = await fetch('https://pendragonish-interstellar-jane.ngrok-free.dev/chat', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ message: q })
    });

    const text = await res.text();
    let data = null; try { data = JSON.parse(text); } catch {}
    area.lastChild.remove(); // remove "Typing…"

    if (!res.ok) {
      console.error('Backend error:', res.status, text);
      addMsg('Assistant', `Server error ${res.status}. Intenta de nuevo / Please try again.`);
      return;
    }
    addMsg('Assistant', (data && data.answer) ? data.answer : 'Sin respuesta / No answer.');
  } catch (e){
    area.lastChild.remove();
    console.error('Network error:', e);
    addMsg('Assistant', 'Error de red / Network error.');
  }
}


  btn.addEventListener('click', ()=>{ panel.style.display='block'; });
  panel.querySelector('#close-ai').addEventListener('click', ()=>{ panel.style.display='none'; });
  panel.querySelector('#send-ai').addEventListener('click', ()=>{
    const q = input.value.trim();
    if(!q) return;
    input.value = '';
    askAI(q);
  });
})();
